module.exports = __webpack_public_path__ + "img/icon-24-ic-chev-n.f174d404.svg";